import { Injectable } from '@angular/core';
import { NzNotificationService } from 'ng-zorro-antd/notification';

export enum NotificationType{
  SUCCESS,
  WARNING,
  INFO,
  ERROR,
}

@Injectable({ providedIn: 'root' })
export class NotificationService {

  createNotification(type: NotificationType, title: string, message: string): void {
    this.notification.create(
      NotificationType[type].toLowerCase(),
      title,
      message,
      {
        nzPlacement: 'topRight'
      }
    );
  }

  constructor(private notification: NzNotificationService) {}
}
